import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import { ReactComponent as SortIcon } from 'common/icons/sort.svg';
import IconButton from 'common/components/IconButton';
import SearchInput from 'common/components/SearchInput';
import useSearch from 'common/hooks/useSearch';
import ClientResponseProps from 'common/types/UserResponseProps';
import { CategoryButton, FullSidebarWrapper, OrderProductTypeButton } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import CategoryProps from 'pages/CreateOrderPage/types/CategoryProps';
import styled from '@emotion/styled';
import Pagination from 'common/components/Pagination';
import useScreenSize from 'common/hooks/useScreenSize';
import sendFetch from 'common/utils/fetch';
import CartButton from 'pages/CreateOrderPage/components/CartButton';
import { FullItem } from '../OrderProductSettings';


type OrderProductPageProps = {
  setStage: (stage: number) => void;
  client: ClientResponseProps | null;
  firm: string;
  priceList: string;
  selectedItem: FullItem;
  setSelectedItem: React.Dispatch<React.SetStateAction<FullItem>>;
  orderId: string | number;
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  itemCount: number;
};

type ServiceProps = {
  id: number | string;
  name: string;
  price: number;
};

type ProductProps = {
  id: number | string;
  name: string;
  price: number;
};

type ListCardProps = {
  name: string;
  price: number | string;
  id: number | string;
  onClick: () => void;
  type: 'services' | 'products';
};

const StyledListCard = styled.div`
    display:flex;
    min-width: 219px;
    flex-basis: auto;
    min-height: 148px;
    flex-shrink: 0;
    border-radius: 8px;
    // opacity .05
    background-color: ${(props) => props.theme.colors.primaryColor + '0D'};
    padding: 16px;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: all .2s ease-in-out;
    &:hover {
        // opacity .1
        background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
    }
`;

const ListCard = ({ name, price, onClick, type }: ListCardProps) => {
  // random length 5 number
  const number = Math.floor(Math.random() * 90000) + 10000;
  return (
    <StyledListCard onClick={onClick}>
      <span className='order-product-list-card-title'>
        {name}
      </span>
      <div className='order-product-list-card-bottom'>
        {type === 'products' ? <span className='order-product-list-card-number'>{`№${number}`}</span> : <div></div>}
        <span className='order-product-list-card-price'>{`${price ? price : '0.00'} ₴`}</span>
      </div>
    </StyledListCard>
  );
};




const useFetchCategories = (orderType: string, setSelectedServiceCategory: React.Dispatch<React.SetStateAction<string | number>>, setSelectedProductCategory: React.Dispatch<React.SetStateAction<string | number>>, setSelectedServiceSubcategory: React.Dispatch<React.SetStateAction<string | number>>) => {
  const [serviceCategories, setServiceCategories] = useState([] as CategoryProps[]);
  const [serviceSubcategories, setServiceSubcategories] = useState([] as CategoryProps[]);
  const [productCategories, setProductCategories] = useState([] as CategoryProps[]);
  console.log(setSelectedProductCategory);
  console.log(setProductCategories);
  useEffect(() => {
    const fetchServiceCategories = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-categories');
      console.log(response);
      if (response[0] === 200 && response[1]?.statusCode === 200) {
        setServiceCategories(response[1].list);
        setSelectedServiceCategory(response[1].list[0].id);
      }
    };
    const fetchServiceSubcategories = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-clothing-type');
      if (response[0] === 200 && response[1]?.status === 'Ok') {
        setServiceSubcategories(response[1].list);
        setSelectedServiceSubcategory(response[1].list[0].id);
      }
    };
    const fetchProductCategories = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-product-category');
      console.log(response);
      if (response[0] === 200 && response[1]?.statusCode === 200) {
        setProductCategories(response[1].list);
        if (response[1].list.length > 0) {
          setSelectedProductCategory(response[1].list[0].id);
        }
      }
    };

    fetchServiceCategories();
    fetchServiceSubcategories();
    fetchProductCategories();
  }, [orderType]);
  return { serviceCategories, serviceSubcategories, productCategories };
};

const useFetchList = (orderType: string, selectedServiceCategory: string | number, selectedServiceSubcategory: string | number, selectedProductCategory: string | number, firm: string, priceList: string, isLegalClient: boolean) => {
  const [serviceList, setServiceList] = useState([] as ServiceProps[]);
  const [productList, setProductList] = useState([] as ProductProps[]);

  useEffect(() => {
    const fetchServiceList = async () => {
      const formData = new FormData();
      formData.append('categoryId', selectedServiceCategory?.toString());
      if (selectedServiceSubcategory) formData.append('clothingTypeId', selectedServiceSubcategory?.toString() || '');
      formData.append('departmentId', firm);
      formData.append('priceList', priceList);
      formData.append('isLegalClient', isLegalClient ? 'true' : 'false');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-service-by-params', {
        method: 'POST',
        data: formData,
      });
      console.log(response);
      if (response[0] === 200 && response[1]?.status === 'Ok') {
        setServiceList(response[1].list);
      }
    };

    const fetchProductList = async () => {
      const formData = new FormData();
      formData.append('id', selectedProductCategory?.toString());

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-product-by-category-id ', {
        method: 'POST',
        data: formData,
      });
      console.log(response);
      if (response[0] === 200 && response[1]?.status === 'Ok') {
        setProductList(response[1].list);
      }
    };

    switch (orderType) {
      case 'services':
        fetchServiceList();
        break;
      case 'products':
        fetchProductList();
        break;
      default:
        break;
    }

  }, [orderType, selectedServiceCategory, selectedServiceSubcategory, firm, priceList, isLegalClient, selectedProductCategory]);

  return { serviceList, productList };
};

const useCalculateCardNumber = (list: ServiceProps[] | ProductProps[], listRef: React.RefObject<HTMLDivElement>, page: number, setPage: React.Dispatch<React.SetStateAction<number>>, height: number, width: number) => {
  const [shownList, setShownList] = useState([] as ServiceProps[] | ProductProps[]);
  const [cardCount, setCardCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  // card width + margin
  const cardWidth = 219 + 16;
  const cardHeight = 148 + 16;
  useEffect(() => {
    if (listRef.current) {
      const listWidth = listRef.current.offsetWidth;
      const listHeight = listRef.current.offsetHeight;
      const cardCountVar = Math.floor(listWidth / cardWidth) * Math.floor(listHeight / cardHeight);
      const pageCountVar = Math.ceil(list.length / cardCountVar);
      const shownListVar = list.slice((page - 1) * cardCountVar, page * cardCountVar);
      console.log('yo');
      console.log(page);
      if (page > pageCountVar && pageCountVar !== 0) setPage(pageCountVar);
      // update only if card count changed
      if (cardCountVar !== cardCount || pageCountVar !== pageCount || shownListVar !== shownList) {
        setCardCount(cardCountVar);
        setPageCount(pageCountVar);
        setShownList(shownListVar);
      }
    }
  }, [list, listRef, page, height, width]);
  return { shownList, cardCount, pageCount };
};

export default function OrderProductPage({ itemCount, setStage, client, firm, priceList, setSelectedItem, setPageType }: OrderProductPageProps) {
  const { searchValue, onSearchChange, clearSearch } = useSearch();
  const [orderType, setOrderType] = useState('services' as string);
  const [selectedServiceCategory, setSelectedServiceCategory] = useState(null as string | number);
  const [selectedServiceSubcategory, setSelectedServiceSubcategory] = useState(null as string | number);
  const [selectedProductCategory, setSelectedProductCategory] = useState(null as string | number);
  const { serviceCategories, serviceSubcategories, productCategories } = useFetchCategories(orderType, setSelectedServiceCategory, setSelectedProductCategory, setSelectedServiceSubcategory);
  console.log('categories');
  console.log(serviceCategories);
  console.log(serviceSubcategories);
  const listRef = useRef(null);
  const [page, setPage] = useState(1);
  const isLegalClient = client?.companyNumber ? true : client?.companyName ? true : false;
  const { serviceList, productList } = useFetchList(orderType, selectedServiceCategory, selectedServiceSubcategory, selectedProductCategory, firm, priceList, isLegalClient);
  const [searchedList, setSearchedList] = useState([] as ServiceProps[] | ProductProps[]);
  useEffect(() => {
    let searchedListVar = orderType === 'products' ? productList : serviceList;
    if (searchValue !== '') {
      searchedListVar = searchedListVar.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase()));
    }
    console.log(searchedListVar);
    setSearchedList(searchedListVar);

  }, [searchValue, orderType, productList, serviceList]);
  const { height, width } = useScreenSize();
  const { shownList, pageCount } = useCalculateCardNumber(searchedList, listRef, page, setPage, height, width);

  console.log(shownList);

  const handleOrderTypeChange = (value: string) => {
    clearSearch();
    setOrderType(value);
  };

  const handleServicePick = (id: number | string, name: string, price: number) => {
    const item: FullItem = {
      type: 'service',
      categoryId: orderType === 'services' ? selectedServiceCategory : selectedProductCategory,
      categoryName: orderType === 'services' ? serviceCategories.find((category) => category.id === selectedServiceCategory)?.name : productCategories.find((category) => category.id === selectedProductCategory)?.name,
      count: 1,
      id,
      name,
      price,
      serviceId: null,
      acDecorId: [],
      adConditionsId: [],
      adServiceId: [],
      brandsId: [],
      clothesGender: 0,
      colorsId: [],
      comment: '',
      defectsId: [],
      departmentId: null,
      marking: 0,
      orderId: null,
      originStainsId: [],
      processingTypesId: [],
      spotsLocationId: [],
      stickingLabel: '',
      defectsSlider: 0,
      attachedPhotos: [],
    };
    setSelectedItem(item);
  };

  const handleProductPick = (id: number | string, name: string, price: number) => {
    const item: FullItem = {
      type: 'product',
      id,
      categoryName: productCategories.find((category) => category.id === selectedProductCategory)?.name,
      name,
      price,
      count: 1,
      productColorsId: [],
      productCoatingId: [],
      productFormId: [],
      productMaterialId: [],
      productSizeId: '',
    };
    setSelectedItem(item);
  };

  return (
    <div className='order-content-container'>
      <div className='order-top-line'>
        <div className='order-top-line-client-wrapper'>
          <p>Клієнт:</p>
          <p className='basic-link' onClick={() => { setStage(1); }}>{client && `${client.lastName} ${client.firstName[0]}.${client.patronymic ? client.patronymic[0] + '.' : ''}`}</p>
        </div>
        <div className='order-top-line-button-wrapper'>
          <SearchInput value={searchValue} onChange={onSearchChange} />
          <IconButton>
            <FilterIcon className='svg-black' />
          </IconButton>
          <IconButton>
            <SortIcon className='svg-black' />
          </IconButton>
          <CartButton itemCount={itemCount} setPageType={setPageType} type='cart' />
        </div>
      </div>
      <div className='order-product-page-wrapper'>
        <div className='order-product-absolute-wrapper'>
          <FullSidebarWrapper>
            <h3 className='new-h3 order-product-category-title'>Категорія</h3>
            <div className='order-product-type-wrapper'>
              <p>Оберіть тип:</p>
              <div className='order-product-type-buttons'>
                <OrderProductTypeButton onClick={() => { handleOrderTypeChange('services'); }} className={orderType === 'services' ? 'active' : ''}>Послуги</OrderProductTypeButton>
                <OrderProductTypeButton onClick={() => { handleOrderTypeChange('products'); }} className={orderType === 'products' ? 'active' : ''}>Товари</OrderProductTypeButton>
              </div>
            </div>
            <div className='order-product-category-wrapper'>
              <div className='order-product-category-list u-fancy-scrollbar'>
                {orderType === 'services' && serviceCategories.map((category, index) => (
                  <CategoryButton className={selectedServiceCategory === category.id ? 'active' : ''} onClick={() => { clearSearch(); setSelectedServiceCategory(category.id); }} key={index}>{category.name}</CategoryButton>
                ))}
                {orderType === 'services' && serviceSubcategories.length > 0 && <>
                  <span className='order-product-category-text'>Тип речі</span>
                  {serviceSubcategories.map((category, index) => (
                    <CategoryButton className={selectedServiceSubcategory === category.id ? 'active' : ''} onClick={() => { clearSearch(); setSelectedServiceSubcategory(category.id); }} key={index}>{category.name}</CategoryButton>
                  ))}
                </>}
                {orderType === 'products' && productCategories.map((category, index) => (
                  <CategoryButton className={selectedProductCategory === category.id ? 'active' : ''} onClick={() => { clearSearch(); setSelectedProductCategory(category.id); }} key={index}>{category.name}</CategoryButton>
                ))}
              </div>
            </div>
          </FullSidebarWrapper>
          <div className='order-product-content-wrapper'>
            <div ref={listRef} className='order-product-list-wrapper'>
              <div className='order-product-list '>
                {orderType === 'services' && shownList.map((service, index) => (
                  <ListCard name={service.name} price={service?.price?.toFixed(2)} id={service.id} onClick={() => { handleServicePick(service.id, service.name, service.price); }} key={index} type='services' />
                ))}
                {orderType === 'products' && shownList.map((product, index) => (
                  <ListCard name={product.name} price={product?.price?.toFixed(2)} id={product.id} onClick={() => { handleProductPick(product.id, product.name, product.price); }} key={index} type='products' />
                ))}
              </div>
            </div>
            <div className='order-pagination-wrapper'>
              {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}